import { combineReducers } from 'redux';

import {
  promosReducerKey,
  promosReducer
} from './RetailerPromos/reducer';

import {
  userFavoritesReducerKey,
  userFavoritesReducer
} from './UserFavorites/reducer';

import {
  checkoutReducerKey,
  checkoutReducer
} from './Checkout/reducer';

export const dataServiceReducerKey = 'dataService';

export const dataServiceReducer = combineReducers({
  [promosReducerKey]: promosReducer,
  [userFavoritesReducerKey]: userFavoritesReducer,
  [checkoutReducerKey]: checkoutReducer
});
